import { type FC } from 'preact/compat';
import "./index.scss";

interface EmailProps {
  autocompleteAttribute?: string;
  enableAutocomplete?: boolean;
  id: string;
  isRequired?: boolean;
  label: string;
  placeholder?: string;
  showLabel?: boolean;
  showValidationMessage?: boolean;
}

export const Email: FC<EmailProps> = ({
  id,
  label,
  autocompleteAttribute = "off",
  enableAutocomplete = false,
  isRequired = false,
  placeholder = "",
  showLabel = true,
  showValidationMessage = false,
}) => {
  const appendAsterisk = isRequired ? "*" : "";

  return (
    <div className="gravity-form-email">
      {showLabel && (
        <label
          className="gravity-form-email__label"
          htmlFor={id}
        >
          {label}
          {appendAsterisk}
        </label>
      )}
      <input
        autocomplete={enableAutocomplete ? autocompleteAttribute : "off"}
        className={`gravity-form-email__input ${showValidationMessage ? 'gravity-form-email__input--invalid' : ''}`}
        type="email"
        name={`input_${id}`}
        placeholder={placeholder}
        id={id}
        required={isRequired}
      />
      {showValidationMessage && (
        <span className="gravity-form-email__message">
          Please enter a valid email address.
        </span>
      )}
    </div>
  );
};
